export default "__VITE_ASSET__DErBnHre__"